import React from 'react';
import {
  PlayIcon,
  StopIcon,
  CheckCircleIcon,
  UserGroupIcon,
  BellIcon,
  CodeBracketIcon,
  ClockIcon,
  ArrowPathIcon,
  ServerIcon,
  CircleStackIcon,
  ArrowsPointingOutIcon,
  ArrowsPointingInIcon,
} from '@heroicons/react/24/outline';

const nodeCategories = [
  {
    name: 'Flow Control',
    items: [
      { type: 'START', label: 'Start', icon: PlayIcon, color: 'text-green-600' },
      { type: 'END', label: 'End', icon: StopIcon, color: 'text-red-600' },
      { type: 'CONDITION', label: 'Condition', icon: ArrowPathIcon, color: 'text-yellow-600' },
      { type: 'PARALLEL_SPLIT', label: 'Parallel Split', icon: ArrowsPointingOutIcon, color: 'text-purple-600' },
      { type: 'PARALLEL_JOIN', label: 'Parallel Join', icon: ArrowsPointingInIcon, color: 'text-purple-600' },
    ],
  },
  {
    name: 'Activities',
    items: [
      { type: 'ACTIVITY', activityType: 'APPROVAL', label: 'Approval', icon: CheckCircleIcon, color: 'text-blue-600' },
      { type: 'ACTIVITY', activityType: 'ASSIGNMENT', label: 'Assignment', icon: UserGroupIcon, color: 'text-indigo-600' },
      { type: 'ACTIVITY', activityType: 'NOTIFICATION', label: 'Notification', icon: BellIcon, color: 'text-yellow-600' },
      { type: 'ACTIVITY', activityType: 'USER_TASK', label: 'User Task', icon: UserGroupIcon, color: 'text-blue-600' },
      { type: 'ACTIVITY', activityType: 'WAIT', label: 'Wait', icon: ClockIcon, color: 'text-gray-600' },
    ],
  },
  {
    name: 'Automation',
    items: [
      { type: 'ACTIVITY', activityType: 'SCRIPT', label: 'Script', icon: CodeBracketIcon, color: 'text-green-600' },
      { type: 'ACTIVITY', activityType: 'SERVICE_TASK', label: 'Service Task', icon: ServerIcon, color: 'text-blue-600' },
      { type: 'ACTIVITY', activityType: 'HTTP_REQUEST', label: 'HTTP Request', icon: ServerIcon, color: 'text-indigo-600' },
      { type: 'ACTIVITY', activityType: 'DATABASE_QUERY', label: 'Database Query', icon: CircleStackIcon, color: 'text-purple-600' },
    ],
  },
];

const Sidebar: React.FC = () => {
  const onDragStart = (event: React.DragEvent, nodeType: string, activityType?: string) => {
    event.dataTransfer.setData('nodeType', nodeType);
    if (activityType) {
      event.dataTransfer.setData('activityType', activityType);
    }
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div className="w-48 bg-white border-r border-gray-200 flex flex-col h-full">
      <div className="p-3 border-b border-gray-200">
        <h3 className="text-sm font-semibold text-gray-900">Activity Palette</h3>
      </div>
      
      <div className="flex-1 overflow-y-auto overflow-x-hidden p-3">
        {nodeCategories.map((category) => (
          <div key={category.name} className="mb-4">
            <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
              {category.name}
            </h4>
            <div className="space-y-1">
              {category.items.map((item) => (
                <div
                  key={`${item.type}-${(item as any).activityType || ''}`}
                  draggable
                  onDragStart={(e) => onDragStart(e, item.type, (item as any).activityType)}
                  className="flex items-center p-1.5 rounded border border-gray-200 cursor-move hover:bg-gray-50 hover:border-gray-300 transition-colors"
                >
                  <item.icon className={`h-4 w-4 mr-1.5 flex-shrink-0 ${item.color}`} />
                  <span className="text-xs text-gray-700 truncate">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;